"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapItem = void 0;
var article_preview_1 = require("../article-preview/article-preview");
var collection_preview_1 = require("../collection-preview/collection-preview");
var video_preview_1 = require("../video-preview/video-preview");
function mapItem(rawPreview) {
    switch (rawPreview.type) {
        case 'article':
            return {
                type: rawPreview.type,
                preview: (0, article_preview_1.createArticlePreview)(rawPreview),
            };
        case 'collection':
            return {
                type: rawPreview.type,
                preview: (0, collection_preview_1.createCollectionPreview)(rawPreview)
            };
        case 'video':
            return {
                type: rawPreview.type,
                preview: (0, video_preview_1.createVideoPreview)(rawPreview)
            };
        default:
            throw new Error("Item type \"".concat(rawPreview.type, "\" is unknown"));
    }
}
exports.mapItem = mapItem;
